var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M12 1.875C6.403 1.875 1.875 6.412 1.875 12c0 5.599 4.535 10.125 10.125 10.125 5.596 0 10.125-4.533 10.125-10.125C22.125 6.379 17.56 1.875 12 1.875zm0-1.5C18.42.375 23.625 5.582 23.625 12c0 6.422-5.205 11.625-11.625 11.625S.375 18.422.375 12C.375 5.582 5.58.375 12 .375zM10.312 16.5h.563v-5.625h-.563c-.31 0-.562-.252-.562-.562v-.375c0-.311.252-.563.562-.563h2.25c.311 0 .563.252.563.563V16.5h.562c.311 0 .563.252.563.563v.375c0 .31-.252.562-.563.562h-3.375c-.31 0-.562-.252-.562-.562v-.375c0-.311.252-.563.562-.563zM12 5.25c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.c7c9d64da1942be8e7bcb517243cf072.svg";
export { ForwardRef as ReactComponent };